// extracted by mini-css-extract-plugin
export default {"header":"AppBar_header__wbecp","headerNav":"AppBar_headerNav__TSOSN","secWrap":"AppBar_secWrap__QW1jP","lang":"AppBar_lang__11ITp"};